import { render, staticRenderFns } from "./CMSContactFormList.vue?vue&type=template&id=54958dbe&"
import script from "./CMSContactFormList.vue?vue&type=script&lang=js&"
export * from "./CMSContactFormList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports